<template>
  <iframe
    v-if="$store.state.dailyCounts.gdsTrendsOverTimeUrl"
    class="g-studio-iframe"
    frameborder="0"
    style="border: 0"
    allowfullscreen
    :src="$store.state.dailyCounts.gdsTrendsOverTimeUrl"
  />
  <div v-else class="g-studio-info-wrapper text-center">
    <span v-if="$store.state.dailyCounts.gdsTrendsOverTimeUrlFailed">
      Congratulations, you've just launched with Covatic insights! Data will be
      appearing here soon…
    </span>
  </div>
</template>

<script>
export default {
  name: "Insights",
}
</script>

<style scoped>
.g-studio-iframe {
  width: 100%;
  /*Maintain aspect ratio*/
  height: calc(100vh - 100px);
}
.g-studio-info-wrapper {
  /* margin: 10px; */
  /* background-color: #F1F1F1; */
  /* padding: 24px 16px; */
  /* border: 0.3px black solid; */
  height: calc(100vh - 100px);
}
</style>
